import { IMAGE, CAROUSEL } from '../../constants';
const COLLISION_COMPONENTS = [CAROUSEL, IMAGE];
const checkColissionTypes = type => COLLISION_COMPONENTS.includes(type);
const checkIfHasCollided = (index, length, collidedWithPrevious, collidedWithNext) => {
  if (index === 0 && collidedWithPrevious) return true;
  if (index === length && collidedWithNext) return true;
  return false;
};
const getCollisions = (name, siblings) => {
  let collidedWithPrevious = false;
  let collidedWithNext = false;
  siblings.find(({
    name: componentName
  }, i) => {
    if (componentName === name) {
      const {
        type: previousType
      } = siblings[i - 1] || {};
      const {
        type: nextType
      } = siblings[i + 1] || {};
      collidedWithPrevious = checkColissionTypes(previousType);
      collidedWithNext = checkColissionTypes(nextType);
    }
    return componentName === name ? i : null;
  });
  return [collidedWithPrevious, collidedWithNext];
};
export { getCollisions, checkIfHasCollided };
//# sourceMappingURL=check-collisions.js.map